const STRONG_PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/**
 * @param {string | null | undefined} password
 * @returns {boolean}
 */
export function isStrongPassword(password) {
  return STRONG_PASSWORD_PATTERN.test(String(password || ""));
}
